import { colors } from 'theme/colors';
import { AcknowledgementState } from 'utils/api/modules/entities/entities.types';

import { StatusOption } from '../StatusPicker/StatusPicker';

// Two-state personal queue: Pending + Acknowledged, both shown by default. Tints mirror
// AcknowledgementStateChip (Pending → warning, Acknowledged → success). Cancelled is never a
// queue row, so it's not an option here.
export const ACKNOWLEDGEMENT_STATUS_OPTIONS: StatusOption<AcknowledgementState>[] = [
  {
    value: AcknowledgementState.Pending,
    label: 'Pending',
    colors: { background: colors.tint.warning.medium, foreground: colors.warning.dark },
  },
  {
    value: AcknowledgementState.Acknowledged,
    label: 'Acknowledged',
    colors: { background: colors.tint.success.medium, foreground: colors.success.dark },
  },
];
